export const NAME_REGEX = new RegExp(/^[a-zA-ZÀ-ÿ\-'\s]+$/);
export const ADDRESS_REGEX = new RegExp(/^$|[a-zA-ZÀ-ÿ0-9.,;'\-&()/\s]+$/);
export const CITY_REGEX = new RegExp(/^[a-zA-ZÀ-ÿ.\-,;&'()/\s]+$/);
export const POSTAL_CODE_REGEX = new RegExp(
  /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/
);
export const ZIP_REGEX = new RegExp(/^\d{5}(-\d{4})?$/);
export const CONTAINS_CARE_OF_REGEX = new RegExp(/(care of|c\s*\/\s*o)/i);
